import { IOperatorInstructionModel } from "../../interfaces/OperatorInstruction/IOperatorInstructionModel";
import {
  IWarningModalModel,
  WarningModalModel,
} from "../../interfaces/WarnigModal/IWarningModalModel";
import {
  SET_CURRENT_INSTRUCTION,
  SET_PREVIOUS_INSTRUCTION,
  InstructionState,
  InstructionActionTypes,
  CLEAR_INSTRUCTIONS,
  TOGGLE_SHOW_INSTRUCTION,
  SET_WARNING_MODAL,
  CLEAR_WARNING_MODAL,
} from "../types/InstructionStateTypes";
import { IPayloadWrapper } from "../types/PayloadWrapper";

/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */
export const setCurrentInstruction = (
  payload: IOperatorInstructionModel,
  meta: () => void
): InstructionActionTypes => {
  return {
    type: SET_CURRENT_INSTRUCTION,
    payload,
    meta,
  };
};

export const setLastInstruction = (payload: IOperatorInstructionModel): InstructionActionTypes => {
  return {
    type: SET_PREVIOUS_INSTRUCTION,
    payload,
  };
};

export const clearInstructions = (): InstructionActionTypes => {
  return {
    type: CLEAR_INSTRUCTIONS,
  };
};

export const toggleShowInstruction = (
  payload: IPayloadWrapper<boolean>
): InstructionActionTypes => {
  return {
    type: TOGGLE_SHOW_INSTRUCTION,
    payload,
  };
};

export const setWarningModal = (
  payload: IWarningModalModel,
  meta: (message: string, error: string, header: string) => void
): InstructionActionTypes => {
  return {
    type: SET_WARNING_MODAL,
    payload,
    meta,
  };
};

export const clearWarninModal = () => {
  return {
    type: CLEAR_WARNING_MODAL,
  };
};

const initialInstructionState: InstructionState = {
  currentInstructionID: -1,
  previousInstructionID: -1,
  currentInstruction: null,
  previousInstruction: null,
  visible: false,
  showWarningModal: false,
  warningModal: new WarningModalModel(),
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const reducer = (
  state: InstructionState = initialInstructionState,
  action: InstructionActionTypes
) => {
  switch (action.type) {
    case SET_CURRENT_INSTRUCTION:
      return {
        ...state,
        currentInstructionID: action.payload!.id,
        currentInstruction: action.payload,
        visible: action.payload!.visible,
      };
    case SET_PREVIOUS_INSTRUCTION:
      return {
        ...state,
        previousInstructionID: action.payload?.id,
        previousInstruction: action.payload,
      };
    case CLEAR_INSTRUCTIONS:
      return { ...initialInstructionState };
    case CLEAR_WARNING_MODAL:
      return { ...state, showWarningModal: false, warningModal: new WarningModalModel() };
    case TOGGLE_SHOW_INSTRUCTION:
      return { ...state, visible: action.payload.value };
    case SET_WARNING_MODAL:
      return {
        ...state,
        showWarningModal: true,
        warningModalMessage: action.payload.message,
        warningModalErrorCode: action.payload.errorCode,
        warningModalHeader: action.payload.header,
      };
    default:
      return state;
  }
};

export default reducer;
